import * as types from "../constants/paymentConstant";
import axios from "axios";
import { getKeycloackToken } from "./auth";
import { notify } from "./snack";

export const setPaymentMethodAndCheckout = (payload) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/payment/checkout`,
      data: payload,
    };
    const {data} = await axios(config);
    dispatch({
      type: types.SET_PAYMENT_METHOD_AND_CHECKOUT,
      payload: {...data},
    });
  } catch (err) {
    dispatch(notify("error", err.toString()));
  }
};


export const getPlans = () => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/pricing/plans`,
    };
    const {data} = await axios(config);
    dispatch({
      type: types.GET_PLANS,
      payload: data.plans,
    });
  } catch (err) {
    dispatch(notify("error", err.toString()));
  }
};

export const getUpgradePreview = (planId, quantity) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/payment/preview-upgrade`,
      data: {planId, quantity}
    };
    const {data} = await axios(config);
    dispatch({
      type: types.GET_PRORATION,
      payload: data.invoicePreview,
    });
  } catch (err) {
    dispatch(notify("error", err.toString()));
  }
};



export const upgrade = ({planId, quantity, type}) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/payment/upgrade`,
      data: {planId, quantity, type}
    };
    const {data} = await axios(config);
    dispatch({
      type: types.SUBSCRIPTION_UPGRADE,
      payload: data.upgradedSubscription,
    });
  } catch (err) {
    dispatch(notify("error", err.toString()));
  }
};


export const createPaymentIntent = (payload) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/payment/intent/create`,
      data: payload,
    };
    const { data } = await axios(config);
    dispatch({
      type: types.CREATE_PAYMENT_INTENT,
      payload: { ...data },
    });
  } catch (err) {
    dispatch(notify("error", err.toString()));
  }
};


export const getOrders = () => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/payment/orders`,
    };
    const {data} = await axios(config);
    dispatch({
      type: types.GET_ORDERS,
      payload: data.orders,
    });
  } catch (err) {
    dispatch(notify("error", err.toString()));
  }
};


export const cancelSubscription = () => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "delete",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/payment/subscription`,
    };
    const {data} = await axios(config);
    dispatch({
      type: types.CANCEL_SUBSCRIPTION,
      payload: data.updatedSubscription,
    });
  } catch (err) {
    dispatch(notify("error", err.toString()));
  }
};
